import { render, staticRenderFns } from "./guize.vue?vue&type=template&id=bdef0910&scoped=true&"
import script from "./guize.vue?vue&type=script&lang=js&"
export * from "./guize.vue?vue&type=script&lang=js&"
import style0 from "./guize.vue?vue&type=style&index=0&id=bdef0910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdef0910",
  null
  
)

export default component.exports